import { default as UIDefault } from './default';

export default {
  UIDefault
};


/** WEBPACK FOOTER **
 ** ./src/UIs/default/index.js
 **/